import { AfterViewInit, Component, OnDestroy, OnInit,ViewChild } from '@angular/core';
import { data_proyecto } from './data';
import { tabla_proyecto } from './data';
import { Chart } from 'chart.js';
import { NgxSpinnerService } from 'ngx-spinner';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { FormatterDolar } from 'src/app/web/util/formatDataTable';
import { ErrorService } from 'src/app/shared/services/errors.service';
import { ApiServiceEjecutive } from '../../../apis/ApiServiceEjecutive';
import Swal from 'sweetalert2';
import { FormatDataTableScroll } from '../../../util/formatDataTable';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { FormatChatsOptionLineGlobal } from 'src/app/web/util/formatChart';

@Component({
  selector: 'app-pagos',
  templateUrl: './pagos.component.html',
  styleUrls: ['./pagos.component.scss']
})
export class PagosJefaturaComponent implements AfterViewInit, OnDestroy, OnInit {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  dtOptions: DataTables.Settings = {};
  formSearch:FormGroup
  listInfOption = [];
  listInfoPlay = [];
  dateGarfi = [];
  payPaidGarfi = [];
  payLateGarfi = [];
  payPendingGarfi = [];
  payDescGarfi = [];
  listFilterClient = [];
  listPlayOption = [];
  listTypeService = [];
  grafico;

  dropdownSettings = {};
  filterOperation = [];
  filterComercialOrigen = [];
  typeMoney = ""

  
  chart1 = {
    data :{
      labels: this.dateGarfi,
      datasets: [{
          label: 'Atrasados',
          data: this.payLateGarfi,
          backgroundColor: 'transparent',
          borderColor: 'red',
          borderWidth: 2,
          
      },
      {
        label: 'Pagos',
        data: this.payPaidGarfi,
        backgroundColor: 'transparent',
        borderColor: 'green',
        borderWidth: 2,
      }
      ,
      {
        label: 'Pendientes',
        data: this.payPendingGarfi,
        backgroundColor: 'transparent',
        borderColor: 'gray',
        borderWidth: 2,
      },
      {
        label: 'Descuento',
        data: this.payDescGarfi,
        backgroundColor: 'transparent',
        borderColor: 'orange',
        borderWidth: 2,
      }
    ]
    },
    options: FormatChatsOptionLineGlobal(),
    plugins: [],

  };

  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private errorService:ErrorService,
    private apiService: ApiServiceEjecutive) { 

  }

  ngOnInit(): void {
    this.formSearch = this.fb.group({
      end_date:[''],
      start_date:[''],
      optionTypePay: 0,
      optionState:'',
      optionClient:0,
      selectComercialOrigen: [''],
      selectOperation: [''],
      optionTypeService: [''],
      currencyTransf: 0,
      });
      if (localStorage.getItem("info-pdg-table") ){
          let rs = JSON.parse(localStorage.getItem("info-pdg-table"));
          if(rs.end_date != ''){
            rs.end_date = moment( rs.end_date, "DD-MM-YYYY").format("YYYY-MM")
            rs.start_date = moment( rs.start_date, "DD-MM-YYYY").format("YYYY-MM")
          }
          this.formSearch.patchValue(rs);
          
      }
      let start_date = "";
      let end_date = "";
      if(this.formSearch.value.end_date != "" && this.formSearch.value.start_date != ""){
        start_date = moment( this.formSearch.value.start_date, 'YYYY-MM').format("DD-MM-YYYY")
        end_date = moment( this.formSearch.value.end_date, 'YYYY-MM').format("DD-MM-YYYY")
      }

    this.dtOptions = FormatDataTableScroll(); 

    let infoModeny = this.formSearch.value.currencyTransf
    if(infoModeny == 0){
      infoModeny = "2"
    }

    this.iniService(start_date, end_date, this.formSearch.value.optionTypePay, this.formSearch.value.optionState, this.formSearch.value.optionClient,  this.formSearch.value.selectComercialOrigen, this.formSearch.value.selectOperation, this.formSearch.value.optionTypeService, infoModeny)
  }

  iniService(startDataSw, endDataSw, typePay, stateSw, clientId, commercialOrigin, operation, typeService, currencyTransf){
    console.log(this.formSearch.value.selectOperation)
    console.log(this.formSearch.value.selectOperation)
    this.spinner.show();
    this.apiService.getService('list-headship-pay?startDataSw='+startDataSw+'&endDataSw='+endDataSw+'&typePay='+typePay+'&stateSw='+stateSw+'&clientId='+clientId+'&commercialOrigin='+commercialOrigin+'&operation='+operation+'&serviceType='+typeService+'&currencyTransf='+currencyTransf+'')
    .subscribe({
      next: (rs: any) => {
      if (rs.code == null) {

        this.listInfOption = rs.listOption
        this.listInfoPlay = rs.listInfoPlay
        this.listTypeService = rs.listServiceType
        this.filterComercialOrigen = rs.listCommercialOrigin
        this.filterOperation = rs.listOperation
      

      if(rs.listInfoGrafit.dateGarfi != null){
        this.dateGarfi = rs.listInfoGrafit.dateGarfi;
        this.payPaidGarfi = rs.listInfoGrafit.payPaidGarfi;
        this.payLateGarfi = rs.listInfoGrafit.payLateGarfi;
        this.payPendingGarfi = rs.listInfoGrafit.payPendingGarfi;
        this.payDescGarfi = rs.listInfoGrafit.payDescGarfi;

          this.listFilterClient = rs.listFilterClient
        
          this.listPlayOption = rs.listPlayOption



      }

      let type = this.listPlayOption.filter( n =>  n.id ==  this.formSearch.value.currencyTransf)
      if(type[0] != null){
        this.typeMoney = type[0].name
      }else{
        this.typeMoney = "UF"
      }
  

      this.spinner.hide();
      this.chart()

      this.rerender();

      } else {
        this.spinner.hide();
        Swal.fire({
          title:  rs.error,
          text: '',
          icon: 'error',
          heightAuto: false
          });
      }
    },
    error: (error) => {
      this.errorService.error(error);
    },
  });
  }

  
  async chart(){

    this.chart1 = {
      data :{
        labels: this.dateGarfi,
        datasets: [{
            label: 'Atrasados',
            data: this.payLateGarfi,
            backgroundColor: 'transparent',
            borderColor: 'red',
            borderWidth: 2,
        },
        {
          label: 'Pagos',
          data: this.payPaidGarfi,
          backgroundColor: 'transparent',
          borderColor: 'green',
          borderWidth: 2,
        }
        ,
        {
          label: 'Pendientes',
          data: this.payPendingGarfi,
          backgroundColor: 'transparent',
          borderColor: 'gray',
          borderWidth: 2,
        },
        {
          label: 'Descuento',
          data: this.payDescGarfi,
          backgroundColor: 'transparent',
          borderColor: 'orange',
          borderWidth: 2,
        }
      ]
      },
      options: FormatChatsOptionLineGlobal(),
      plugins: [],
      
    };
    this.grafico = new Chart('chart-line',  {
      type: 'line',
      data: this.chart1.data,
      options: this.chart1.options
     });

  }

  download(){
    if(this.formSearch.value.end_date < this.formSearch.value.start_date){
      Swal.fire({title: 'La fecha de incio, no debe ser mayor a la fecha de termino' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
    Swal.fire({
      title: 'Descargar',
      text: '¿Desea descargar el archivo?',
      icon: 'warning',
      showCancelButton:true,
      confirmButtonText: 'Descargar',
      cancelButtonText:"No, cancelar",
      heightAuto: false
    }).then((res) => {
      if (res.isConfirmed) {
        
        let start_date = "";
        let end_date = "";
        let typePay = this.formSearch.value.optionTypePay;
        let stateSw = this.formSearch.value.optionState;
        let clientId =  this.formSearch.value.optionClient;
        let commercialOrigin = this.formSearch.value.selectComercialOrigen;
        let operation = this.formSearch.value.selectOperation;
        let typeService = this.formSearch.value.optionTypeService;
        if(this.formSearch.value.end_date != "" && this.formSearch.value.start_date != ""){
          start_date = moment( this.formSearch.value.start_date, 'YYYY-MM').format("DD-MM-YYYY")
          end_date = moment( this.formSearch.value.end_date, 'YYYY-MM').format("DD-MM-YYYY")
        }
        let infoModeny = this.formSearch.value.currencyTransf
        if(infoModeny == 0){
          infoModeny = "2"
        }
        let urlInfo = ""
        if(start_date == '' || end_date== ''){
          urlInfo = 'dowload-document-excel-headship-pay?typePay='+typePay+'&stateSw='+stateSw+'&clientId='+clientId+'&commercialOrigin='+commercialOrigin+'&operation='+operation+'&serviceType='+typeService+'&currencyTransf='+ infoModeny+''
        }else{
          urlInfo = 'dowload-document-excel-headship-pay?startDataSw='+start_date+'&endDataSw='+end_date+'&typePay='+typePay+'&stateSw='+stateSw+'&clientId='+clientId+'&commercialOrigin='+commercialOrigin+'&operation='+operation+'&serviceType='+typeService+'&currencyTransf='+ infoModeny+''
        }

        this.spinner.show()
       this.apiService.DownloadService(urlInfo).subscribe({
          next: (rs: any) => {
              let dataType = rs.type;
              let ext = dataType.split('/')
              let binaryData = [];
              binaryData.push(rs);
              let downloadLink = document.createElement('a');
              downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
              if(ext[1] != null){
                downloadLink.setAttribute('download','document.'+ext[1]);
              }
              this.spinner.hide();
              document.body.appendChild(downloadLink);
              downloadLink.click();
          },
          error: (error) => {
            const errorJson = JSON.parse(this.blobToString(error.error));
            if(errorJson.code == 1){
              this.spinner.hide()
              Swal.fire({title:errorJson.error,text: '',icon: 'error',heightAuto: false});
            }else{
              this.errorService.error(error);
            }
          },})
      }
      else if ( res.dismiss === Swal.DismissReason.cancel){
        Swal.fire({
          title: 'Cancelado',
          text: 'Operación cancelada.',
          icon: 'error',
          heightAuto: false
        })

      }
    });
  }

  private blobToString(blob): string {
    const url = URL.createObjectURL(blob);
    let xmlRequest = new XMLHttpRequest();
    xmlRequest.open('GET', url, false);
    xmlRequest.send();
    URL.revokeObjectURL(url);
    return xmlRequest.responseText;
}

  ngAfterViewInit(): void {
    
  }

  limpButton(){
    localStorage.removeItem("info-pdg-table")
    location.replace(`/pdg/headship/payments`)
  }

  formSubmit(){

    if(this.formSearch.value.end_date < this.formSearch.value.start_date){
      Swal.fire({title: 'La fecha de incio, no debe ser mayor a la fecha de termino' ,text: '',icon: 'error',heightAuto: false});
      return;
    }

    if(this.formSearch.value.end_date == "" && this.formSearch.value.start_date == ""){
      
      this.localSave();

    }else if(this.formSearch.value.end_date != "" && this.formSearch.value.start_date != ""){
      this.localSave();

    }else{
      Swal.fire({title: 'Debe seleccionar fecha incio y termino o dejarla en blanco' ,text: '',icon: 'error',heightAuto: false});
      return;
    }

  }

  localSave(){
    let start_date = this.formSearch.value.start_date
    let end_date = this.formSearch.value.end_date
    if(this.formSearch.value.end_date != "" && this.formSearch.value.start_date != ""){
      start_date = moment( this.formSearch.value.start_date, 'YYYY-MM').format("DD-MM-YYYY")
      end_date = moment( this.formSearch.value.end_date, 'YYYY-MM').format("DD-MM-YYYY")
    }
    let inf = {
      start_date: start_date,
      end_date: end_date,
      optionTypePay: this.formSearch.value.optionTypePay,
      optionState: this.formSearch.value.optionState,
      optionClient: this.formSearch.value.optionClient,
      currencyTransf: this.formSearch.value.currencyTransf,
      selectOperation: this.formSearch.value.selectOperation,
      optionTypeService: this.formSearch.value.optionTypeService,
      selectComercialOrigen: this.formSearch.value.selectComercialOrigen,
    }

    localStorage.setItem("info-pdg-table", JSON.stringify(inf));
    location.replace(`/pdg/headship/payments`)
  }


  ngOnDestroy(): void {
    localStorage.removeItem("info-pdg-table")
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtTrigger.next();
  }
}


